import '../../styles/blocks/_blowup-modal.scss';
import '../../styles/blocks/_modal-cancel.scss';
import '../RAComponents/commons/RAModal/RAModal.scss';

import React from 'react';
import { history } from 'routes/history';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormattedText, formatText } from 'core/i18n';
import Storage from 'utilities/storage';
import modalCancelActions from 'actions/modalCancelActions';
import suitabilityActions from 'actions/RASuitabilityTest';
import { actions as formActions } from 'react-redux-form';
import stepsActions from 'actions/stepsActions';
import { recordAndSavePage } from 'actions/errorViewNavigation';
import UtagHelper from 'utilities/utagHelper';
import { recordEvent, RELIABLE, PAGE_PRODUCT } from 'utilities/uTagging';
import { getCurrentStep } from 'utilities/RASuitabilityTestHelper';
import cryptoJS from 'crypto-js';
import {
    EVENT_CATEGORY_SUITABILITY_TEST,
    EVENT_ACTION_MODAL_VIEW,
    EVENT_ACTION_EXIT_TEST,
    TEST_PROCESS_STEP,
    EVENT_DETAIL_CLOSE_MODAL,
    EVENT_DETAIL_MODAL_EXIT_NEXT,
} from 'constants/uTagConstants/RAConstants';
import { PATH_MODAL_EXIT } from 'constants/uTagConstants/paths';
import OkModalOnboarding from 'components/commons/OkModalOnboarding/OkModalOnboarding.jsx';
import { BASE_PATH } from 'constants/index';

class ModalCancel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            blowupClass: 'blowup-modal blowup-in',
        };
    }

    handleBlowupClass = () => {
        this.setState({ blowupClass: 'blowup-modal blowup-out' });
        setTimeout(() => {
            this.handleClose();
        }, 200);
    };

    handleClose = () => {
        const { userProfile } = this.props;
        const { docNumber } = userProfile;
        const docNumberEncrypted = docNumber ? cryptoJS.SHA256(docNumber).toString() : '';
        if (!userProfile.testStarted) {
            recordEvent(
                PATH_MODAL_EXIT,
                PAGE_PRODUCT,
                'continuar en el onboarding',
                'continuar en el onboarding correcto',
                userProfile.recordId,
                userProfile.userId,
                RELIABLE[userProfile.identityMethod],
                userProfile.investmentType,
                docNumberEncrypted
            );
        } else {
            const currentIndex = this.getCurrentIndexTest();
            const eventAction = TEST_PROCESS_STEP[currentIndex] || '';

            UtagHelper.recordEventRoboGBI(
                PATH_MODAL_EXIT,
                EVENT_CATEGORY_SUITABILITY_TEST,
                eventAction,
                EVENT_DETAIL_CLOSE_MODAL,
                userProfile
            );
        }
        this.props.actions.hideModalCancel();
    };

    handleCancelProcess = () => {
        const { userProfile } = this.props;
        const { docNumber } = userProfile;
        const docNumberEncrypted = docNumber ? cryptoJS.SHA256(docNumber).toString() : '';

        if (userProfile.testStarted) {
            const currentIndex = this.getCurrentIndexTest();
            const eventAction = TEST_PROCESS_STEP[currentIndex] || '';
            UtagHelper.recordEventRoboGBI(
                PATH_MODAL_EXIT,
                EVENT_CATEGORY_SUITABILITY_TEST,
                eventAction,
                EVENT_DETAIL_MODAL_EXIT_NEXT,
                userProfile
            );
        } else {
            recordEvent(
                PATH_MODAL_EXIT,
                PAGE_PRODUCT,
                'continuar en el onboarding',
                'continuar en el onboarding correcto',
                userProfile.recordId,
                userProfile.userId,
                RELIABLE[userProfile.identityMethod],
                userProfile.investmentType,
                docNumberEncrypted
            );
        }

        this.props.actions.hideModalCancel();
    };

    handleContinueLater = () => {
        const { userProfile, stepsActions, immStepsState, actions } = this.props;
        const { docNumber } = userProfile;
        const docNumberEncrypted = docNumber ? cryptoJS.SHA256(docNumber).toString() : '';

        const currentIndex = immStepsState.get('currentStep');
        actions.hideModalCancel();

        if (Storage.cookies.get('RASuitabilityStarted')) {
            stepsActions.enablePreviousSteps({
                index: currentIndex,
            });
        }

        if (userProfile.testStarted) {
            const currentIndex = this.getCurrentIndexTest();
            const eventAction = TEST_PROCESS_STEP[currentIndex] || '';
            UtagHelper.recordEventRoboGBI(
                PATH_MODAL_EXIT,
                EVENT_CATEGORY_SUITABILITY_TEST,
                eventAction,
                EVENT_ACTION_EXIT_TEST,
                userProfile
            );
        } else {
            recordEvent(
                PATH_MODAL_EXIT,
                PAGE_PRODUCT,
                'salir del onboarding',
                'salir del onboarding correcto',
                userProfile.recordId,
                userProfile.userId,
                RELIABLE[userProfile.identityMethod],
                userProfile.investmentType,
                docNumberEncrypted
            );
        }
        history.push(`${BASE_PATH}/logout`);
    };

    getCurrentIndexTest = () => {
        const { RATestWizard } = this.props;
        const { currentStep } = RATestWizard;
        const { currentSubStep } = RATestWizard;

        return getCurrentStep(currentStep, currentSubStep) + 1;
    };

    renderCancelModalFooter = (primaryButtonText, secondaryButtonText) => {
        return (
            <div className="modal-cancel__footer__buttons modal-cancel__footer__buttons--more-one">
                <button className="form__button form__button-clean" onClick={this.handleContinueLater}>
                    {secondaryButtonText}
                </button>
                <button className="form__button form__button-secondary" onClick={this.handleCancelProcess}>
                    {primaryButtonText}
                </button>
            </div>
        );
    };

    render() {
        const { recordAndSavePage } = this.props;
        const suitabilityTest = Storage.cookies.get('RASuitabilityStarted');
        let title = formatText('modalCancel-title');
        let text = <FormattedText value="modalCancel-description" />;
        let primaryButtonText = <FormattedText value="button-continueProcess2" />;
        let secondaryButtonText = <FormattedText value="button-exit" />;
        if (this.props.modalCancel.get('showModal')) {
            const { userProfile, products } = this.props;
            const JointHolderInfo = UtagHelper.getJointHolderInfoFromUserProfile(userProfile);

            if (suitabilityTest) {
                const currentIndex = this.getCurrentIndexTest();
                const eventDetail = TEST_PROCESS_STEP[currentIndex] || '';
                UtagHelper.recordEventRoboGBI(
                    PATH_MODAL_EXIT,
                    EVENT_CATEGORY_SUITABILITY_TEST,
                    EVENT_ACTION_MODAL_VIEW,
                    eventDetail,
                    userProfile
                );
                title = formatText('suitabilityTest-exitModalTitle');
                text = <div className="modal-body--warning">{formatText('suitabilityTest-exitModalText')}</div>;
                primaryButtonText = <FormattedText value="suitabilityTest-exitModalContinueButton" />;
                secondaryButtonText = <FormattedText value="suitabilityTest-exitModalExitButton" />;
            } else {
                const docNumberEncrypted = userProfile.docNumber
                    ? cryptoJS.SHA256(userProfile.docNumber).toString()
                    : '';
                recordAndSavePage(
                    PATH_MODAL_EXIT,
                    userProfile.recordId,
                    userProfile.userId,
                    userProfile.product,
                    products.get('productsDescription'),
                    userProfile.promoCode ? userProfile.promoCode : '',
                    JointHolderInfo,
                    RELIABLE[userProfile.identityMethod],
                    '',
                    userProfile.investmentType,
                    {
                        identificadorOnboarding: docNumberEncrypted,
                        categoriaEvento: 'eventos onboarding',
                        accionEvento: 'clickLink',
                        etiquetaEvento: 'salir',
                    }
                );
            }
        }

        return (
            <React.Fragment>
                <OkModalOnboarding
                    className="modal-cancel"
                    onClose={this.handleBlowupClass}
                    header={<h3 className="font-heading3">{title}</h3>}
                    body={<div className="modal-cancel__body">{text}</div>}
                    modalIsOpen={this.props.modalCancel.get('showModal')}
                    footer={this.renderCancelModalFooter(primaryButtonText, secondaryButtonText)}
                />
            </React.Fragment>
        );
    }
}

module.exports.constructor = ModalCancel;
module.exports.ModalCancel = connect(
    state => ({
        userProfile: state.userProfile,
        modalCancel: state.modalCancel,
        products: state.products,
        immStepsState: state.steps,
        RATestWizard: state.raSuitabilityTestWizard,
        immSuitabilityTest: state.raSuitabilityTest,
    }),
    dispatch => ({
        actions: bindActionCreators(modalCancelActions, dispatch),
        suitabilityActions: bindActionCreators(suitabilityActions, dispatch),
        formActions: bindActionCreators(formActions, dispatch),
        stepsActions: bindActionCreators(stepsActions, dispatch),
        recordAndSavePage: bindActionCreators(recordAndSavePage, dispatch),
    })
)(ModalCancel);
